module.exports = __webpack_public_path__ + "img/image42.99f19772.jpg";